import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxSelect from "src/components/select/SfxSelect.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { SelectInequality } from "src/util/types/components/sfxSelectInequality"
import { computed, PropType, ref, watch } from "vue"

//region Props and Emits

type SelectInequalityOptions = {
  label: string // The font-awesome icon
  value: SelectInequality
}

const ICON_SIZE = "24px"

//endregion

//region Setup Code


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSelectInequality',
  props: {
  modelValue: {
    type: String as PropType<SelectInequality>,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

// Currently the label and values match, but better to keep them separate in case we want to change later
const inequalityOptions = ref<SelectInequalityOptions[]>([
  { label: Icons.LESS_THAN, value: "less-than" },
  { label: Icons.LESS_THAN_EQUAL, value: "less-than-equal" },
  { label: Icons.GREATER_THAN, value: "greater-than" },
  { label: Icons.GREATER_THAN_EQUAL, value: "greater-than-equal" },
])

const optionValues = computed(() => inequalityOptions.value.map((i) => i.value))

watch(
  () => props.modelValue,
  (val) => {
    if (typeof val !== "string" || !optionValues.value.includes(val)) {
      model.value = "less-than"
    }
  },
  { immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(SfxSelect, _mergeProps(_ctx.$attrs, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    options: inequalityOptions.value,
    "emit-value": "",
    "map-options": ""
  }), {
    option: _withCtx((scope) => [
      _createElementVNode("div", _mergeProps(scope.itemProps, { class: "q-py-sm q-px-md" }), [
        _createVNode(_component_q_icon, {
          name: scope.opt.label,
          size: ICON_SIZE,
          color: "fun-label-and-icon"
        }, null, 8, ["name"])
      ], 16)
    ]),
    "selected-item": _withCtx((scope) => [
      _createElementVNode("div", _mergeProps(scope.itemProps, { class: "q-pl-xs" }), [
        _createVNode(_component_q_icon, {
          name: scope.opt.label,
          size: ICON_SIZE,
          color: "fun-label-and-icon"
        }, null, 8, ["name"])
      ], 16)
    ]),
    _: 1
  }, 16, ["modelValue", "options"]))
}
}

})